import { Text } from '../../text';
import { useSliderContext } from '../provider';

interface LabelProps {
  isMin?: boolean;
}

export const Label = ({ isMin }: LabelProps) => {
  const { min, max, formatValue } = useSliderContext();

  return (
    <>
      {isMin && (
        <Text size='large' color='subdued'>
          {formatValue ? formatValue(min) : min}
        </Text>
      )}
      {!isMin && (
        <Text size='large' color='subdued'>
          {formatValue ? formatValue(max) : max}
        </Text>
      )}
    </>
  );
};
